export default "__VITE_ASSET__CIRvOBKK__"